import Vue from 'vue';

export default Vue.component('tab', {
    template:`
        <div v-bind:id="id" class="tab-pane" v-bind:class="[{ active: isActive }, panelCssClass]">
            <div class="is-loading" style="height: 130px;"></div>
        </div>
    `,
    props:{
        id: String,
        title: String,
        isActive: Boolean,
        isEnabled: Boolean,
        panelCssClass: String,
        componentType: String
    },
    methods:{
        renderTabContent(content){            
            return window.$(this.$el).html(content);
        }
    },
    mounted(){
    },
    created() {
    }
});